var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"kst-button",class:_vm.AppCatalog.Router.Back.Class,attrs:{"icon-left":_vm.AppCatalog.Router.Back.Icon,"label":_vm.AppCatalog.Router.Back.Label},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }